////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// drag/index.ts — barrel re-export of DragManager sub-controllers.
// ----------------------------------------------------------------------------------------------------
// Consumed by ../index.ts which namespace-merges these classes into
// window.FTEncounterMap.drag.* alongside the Phase 0 pure helpers.
////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export { TokenDragController }         from './TokenDragController';
export {
    collectDifficultTerrainRegions,
    difficultRegionsEmpty,
    sampleDifficultSegments,
} from './difficult-terrain';
